export const SCROLLING_DURATION = 400; // ms
export const APP_HEADER_HEIGHT = 60; // px
export const PAGE_HEADER_HEIGHT = 56;
export const NAV_SECTION_HEIGHT = 48;
export const TOP_OFFSET =
  APP_HEADER_HEIGHT + PAGE_HEADER_HEIGHT + NAV_SECTION_HEIGHT;
